export default __webpack_public_path__ + "static/media/partner13.bfb9ce79.webp";